import * as actionTypes from "./actionTypes";
import { COMMENT_SUCCESS } from "../issues";

const INITIAL_STATE = {
  action: undefined,
  equipRules: [],
  rules: [],
  comments: [],
  userAccess: [],
  isLoading: false,
  isRulesLoading: false,
  isCommentsLoading: false,
  isPending: false,
  submitError: "",
};

export function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Loading in the action for editing
    case actionTypes.LOAD_ACTION_REQUEST:
      return {
        ...state,
        isLoading: true,
        comments: [],
        userAccess: [],
        action: undefined,
      };
    case actionTypes.LOAD_ACTION_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        action: {
          ...action.result,
          skysparkLink: action.result.skyspark_link,
          screenshotLink: action.result.screenshot_link,
          totalFinancialImpact: action.result.total_financial_impact,
          operationalSavings: action.result.operational_savings,
          transitionReason: action.result.transition_reason,
          status: action.result.bonfire_status,
          rule: action.result.spark_type,
          assignee: action.result.insite_assignee,
        },
      };
    case actionTypes.LOAD_ACTION_REQUEST_FAIL:
      return { ...state, isLoading: false };

    case actionTypes.ACTION_NOT_FOUND:
      return { ...state, isLoading: false, action: undefined };

    // Loading comments
    case actionTypes.LOAD_COMMENTS_REQUEST:
      return { ...state, isCommentsLoading: true };
    case actionTypes.LOAD_COMMENTS_REQUEST_SUCCESS:
      return { ...state, comments: action.result, userAccess: [], isCommentsLoading: false };
    case actionTypes.LOAD_COMMENTS_REQUEST_FAIL:
      return { ...state, comments: [], isCommentsLoading: false };
    // TODO: This exists in the old issues code
    case COMMENT_SUCCESS:
      return { ...state, comments: [...state.comments, action.result] };

    // Loading in the rule list
    case actionTypes.LOAD_RULES_REQUEST:
      return { ...state, isRulesLoading: true };
    case actionTypes.LOAD_RULES_REQUEST_SUCCESS:
      return {
        ...state,
        isRulesLoading: false,
        rules: action.result.sort(),
      };
    case actionTypes.LOAD_RULES_REQUEST_FAIL:
      return { ...state, isRulesLoading: false };

    // Saving an action
    case actionTypes.SAVE_ACTION: {
      return {
        ...state,
        submitError: "",
        isPending: true,
      };
    }
    case actionTypes.SAVE_ACTION_REQUEST_SUCCESS:
      return { ...state, isPending: false };
    case actionTypes.SAVE_ACTION_REQUEST_FAIL: {
      return {
        ...state,
        submitError: action.error.message,
        isPending: false,
      };
    }

    // Adding an action
    case actionTypes.ADD_ACTION:
      return {
        ...state,
        isPending: true,
        submitError: "",
      };
    case actionTypes.ADD_ACTION_REQUEST_SUCCESS:
      return { ...state, isPending: false };
    case actionTypes.ADD_ACTION_REQUEST_FAIL:
      return {
        ...state,
        submitError: action.error.message,
        isPending: false,
      };

    // Attachments
    case actionTypes.ATTACHMENT_UPLOAD_FAIL: {
      return {
        ...state,
        submitError: action.message,
        isPending: false,
      };
    }

    default:
      return state;
  }
}
